import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Login } from './Login';
import { Recover } from './Recover';
import { AuthenticationOptions } from './AuthenticationOptions';
import { Reset } from './Reset';
import { useAuthentication } from './useAuthentication';
import { config } from '../../config';
import { useAuthContext, UserAuthenticated } from '../../context';

const Authentication = () => {
  const { authStatus } = useAuthContext();
  const location = useLocation();
  const { login, recover, reset, change, email, updateEmail, workflow, updateWorkflow } =
    useAuthentication();
  const featuresByLocation = config.featuresByLocation as Record<string, unknown> | undefined;
  const fromPath = (location.state as { from?: string } | undefined)?.from;
  const fromSegment = fromPath?.split('/').filter(Boolean)[0];
  const returnPath =
    fromSegment && featuresByLocation && Object.keys(featuresByLocation).includes(fromSegment)
      ? `/${fromSegment}`
      : '/';

  if (authStatus === UserAuthenticated.YES) {
    return <Navigate to={returnPath} replace />;
  }

  return (
    <>
      {workflow === 'recover' && (
        <Recover onSubmit={recover} email={email} updateEmail={updateEmail} />
      )}
      {workflow === 'reset' && <Reset onSubmit={reset} />}
      {workflow === 'change' && (
        <Login
          email={email}
          isEmailDisabled={true}
          message={'Please choose a new password to continue.'}
          updateEmail={updateEmail}
          onSubmit={change}
        />
      )}
      {workflow !== 'recover' && workflow !== 'reset' && workflow !== 'change' && (
        <Login email={email} updateEmail={updateEmail} onSubmit={login} />
      )}
      {workflow !== 'recover' && workflow !== 'reset' && (
        <AuthenticationOptions workflow={workflow} updateWorkflow={updateWorkflow} />
      )}
    </>
  );
};

export { Authentication };
